@use '../../../styles/variables' as *;
@use '../../../styles/colors' as *;

.error-with-retry {
  display: flex;
  flex-direction: column;
}

.error-with-retry__content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  background: $bg-danger-light;
  border-radius: $radius-md;

  .body-text {
    color: $text-primary;
  }
}

.error-with-retry__icon {
  width: 16px;
  height: 16px;
}
